import * as React from "react";
import { useCallback, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { SystemFields } from "@graylog/server-api";
import { HelpBlock, Input } from "components/bootstrap";
import Select from "components/common/Select/Select";
import Spinner from "components/common/Spinner";
import { naturalSortIgnoreCase } from "util/SortUtils";
const noop = () => {
};
const prepareOptions = (data) => data.fields.sort(naturalSortIgnoreCase).map((fieldName) => ({ label: fieldName, value: fieldName }));
const TypeAheadFieldInput = ({
  id,
  autoFocus = false,
  label = void 0,
  onChange = noop,
  onBlur = noop,
  error = void 0,
  name = void 0,
  defaultValue = void 0
}) => {
  const { data, isInitialLoading } = useQuery({
    queryKey: ["system", "fields"],
    queryFn: () => SystemFields.fields()
  });
  const options = useMemo(() => isInitialLoading ? [] : prepareOptions(data), [data, isInitialLoading]);
  const _onChange = useCallback(
    (fieldName) => onChange({ target: { value: fieldName, name } }),
    [name, onChange]
  );
  return isInitialLoading ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(Input, { label, error }, /* @__PURE__ */ React.createElement(
    Select,
    {
      allowCreate: true,
      inputId: id,
      onChange: _onChange,
      onBlur,
      value: defaultValue,
      options,
      placeholder: "Select Field",
      autoFocus
    }
  ), /* @__PURE__ */ React.createElement(HelpBlock, null));
};
export default TypeAheadFieldInput;
